import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MapLayerGroupService {
  API_SERVER: string = `${environment.baseApiUrl}map-layer-group/`;

  constructor(private httpClient: HttpClient) {}

  findOne(locationId): Observable<any> {
    return this.httpClient.get(this.API_SERVER + `${locationId}`);
  }

  createGroup(data): Observable<any> {
    return this.httpClient.post(this.API_SERVER + 'group', data);
  }

  createSubgroup(locationId, data): Observable<any> {
    return this.httpClient.post(
      this.API_SERVER + `subgroup/${locationId}`,
      data
    );
  }

  updateGroup(id, data): Observable<any> {
    return this.httpClient.put(this.API_SERVER + `group/${id}`, data);
  }

  updateSubgroup(id, locationId, data): Observable<any> {
    return this.httpClient.put(
      this.API_SERVER + `subgroup/${id}/${locationId}`,
      data
    );
  }

  removeGroup(id, locationId): Observable<any> {
    return this.httpClient.delete(
      this.API_SERVER + `group/${id}/${locationId}`
    );
  }

  removeSubgroup(id, locationId): Observable<any> {
    return this.httpClient.delete(
      this.API_SERVER + `subgroup/${id}/${locationId}`
    );
  }
}
